const MONTH_NAMES: string[] = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

// Helper function to format a Date object into "Month Day, Year"
export function getDate(date: Date): string {
  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return 'Invalid Date';
  }

  const day: number = date.getUTCDate();
  const year: number = date.getUTCFullYear();
  const monthIndex: number = date.getUTCMonth();
  return `${MONTH_NAMES[monthIndex]} ${day}, ${year}`;
}

/**
 * Formats a Date object into "MM/DD/YYYY"
 */
export function getNumericDate(date: Date): string {
  if (isNaN(date.getTime())) {
    return 'Unknown date';
  }
  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const year = date.getUTCFullYear();
  return `${month}/${day}/${year}`;
}

// useFormatDate returns a utility object with a formatDate method
export function useFormatDate(): { formatDate: (date: Date) => string } {
  return {
    formatDate: getDate, // Ensure that Date object is passed to getDate
  };
}
